import { CSSObject } from '@chakra-ui/react';

export const IconCircleOutline: CSSObject = {
  boxSize: '6',
  color: 'beta.300',
};

export const DrawerHeaderContainer: CSSObject = {
  borderBottom: 'none',
};
